<template>
  <v-dialog
    v-model="passwordChangeDialog"
    fullscreen
    hide-overlay
    eager
    persistent
    no-click-animation
    transition="slide-x-transition">
    <v-app-bar
      :style="'background-color: ' + appColour"
      :dark="darkToolbar"
      fixed
      v-touch="{ right: () => closeDialog() }">
      <v-btn
        icon
        @click.native="closeDialog()">
        <v-icon>arrow_back</v-icon>
      </v-btn>
      <v-toolbar-title class="ml-0">Change Password</v-toolbar-title>
      <v-spacer/>
    </v-app-bar>
    <v-content>
      <v-container>
        <v-row
        >
          <v-col
            lg="8"
            offset-lg="2"
            cols="12">
            <v-form
              v-model="valid"
              ref="form"
              lazy-validation>
              <!-- :append-icon="showPassword ? 'visibility_off' : 'visibility'"
                  :type="showPassword ? 'text' : 'password'"
                  @click:append="showPassword = !showPassword" -->
              <!--              <v-text-field-->
              <!--                v-model="currentPw"-->
              <!--                :rules="passwordRules"-->
              <!--                prepend-icon="lock"-->
              <!--                type="password"-->
              <!--                label="Current Password"-->
              <!--                required />-->
              <v-text-field
                v-model="newPw"
                :rules="passwordRules"
                prepend-icon="lock"
                type="password"
                label="New Password"
                required />
              <v-text-field
                v-model="newPwConfirm"
                :rules="confirmPasswordRules"
                prepend-icon="lock"
                type="password"
                label="Confirm New Password"
                required />
            </v-form>
          </v-col>
          <v-col
            lg="4"
            offset-lg="4"
            cols="8"
            offset="2">
            <v-btn
              large
              block
              color="primary"
              @click="submitChangePassword()">
              Change password
            </v-btn>
            <p
              v-if="passwordResponseMessage !== ''"
              class="text-center"
              :class="responseMessageColourClass">{{ passwordResponseMessage }}</p>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-dialog>
</template>

<script>
export default {
  props: {
    passwordChangeDialog: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    passwordResponseMessage: '',
    responseMessageColourClass: '',
    // showPassword: false,
    // currentPw: '',
    newPw: '',
    newPwConfirm: '',
    valid: true
  }),

  computed: {
    darkToolbar () { return this.$store.state.darkToolbar },
    appColour () { return this.$store.state.appColour },
    passwordRules () {
      return [
        v => !!v || 'Password can not be empty'
      ]
    },
    confirmPasswordRules () {
      return [
        v => !!v || 'Password can not be empty',
        v => (!!v && v) === this.newPw || 'New password does not match'
        // v => (!!v && v) !== this.currentPw || 'New password can not be the same as current password'
      ]
    }
  },

  methods: {
    closeDialog () {
      this.passwordResponseMessage = ''
      this.$refs.form.reset()
      this.$emit('closedialog')
    },

    submitChangePassword () {
      if (this.$refs.form.validate()) {
        this.$store.commit('loading', true)
        this.$http.post('changepassword', { // one request
          'userId': this.$store.state.userId,
          // 'currentPassword': this.currentPw,
          'newPassword': this.newPw,
          'newPasswordConfirm': this.newPwConfirm
        })
          .then(resp => {
            this.$store.commit('loading', false)
            if (resp.data.success) {
              this.responseMessageColourClass = 'green--text'
              this.passwordResponseMessage = resp.data.statusMessage
            } else {
              this.responseMessageColourClass = 'red--text'
              this.passwordResponseMessage = resp.data.statusMessage
            }
          })
      }
    }
  }
}
</script>

<style scoped>
/* Change dialog background to white, so that it covers the bottom part which was visible */
.v-dialog__content--active {
  background-color: white;
}
</style>
